import React from 'react';
import PropTypes from 'prop-types';
import css from './TableInformation.scss';
import SelectionInformation from './SelectionInformation';
import DisplayInformation from './DisplayInformation';

function TableInformation(props) {
  return props.totalItems > 0 
    ? (
      <footer className={css['table-information']}>
        <SelectionInformation totalSelected={props.totalSelected} />
        <DisplayInformation itemName={props.itemName} 
                            itemsPerPage={props.itemsPerPage} 
                            start={props.start} 
                            totalItems={props.totalItems} />
      </footer>
    )
    : null
}

TableInformation.propTypes = {
  itemName: PropTypes.string.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  totalSelected: PropTypes.number.isRequired
}

export default TableInformation;
